import * as React from 'react';
import * as styles from './styles.css';

export interface IButtonGroupProps {
  children: React.ReactElement | React.ReactElement[];
  startActiveIndex?: number;
  onChange(index: number): void;
}

export function ButtonGroup({ children, onChange, startActiveIndex = 0 }: IButtonGroupProps) {
  const [activeIndex, setActiveIndex] = React.useState(startActiveIndex);

  return (
    <div className={styles['container']}>
      {React.Children.map(children, (child, index) => {
        return React.cloneElement(child, {
          onClick: () => {
            onChange(index);
            setActiveIndex(index);
          },
          isActive: activeIndex === index,
        });
      })}
    </div>
  );
}
